import Box from "@mui/material/Box";
import { CircularProgress, Grid, TextField, Typography } from "@mui/material";
import AppButton from "../../common/AppButton";
import { useAppDispatch } from "../../../app/hooks";
import { addSupplierValidationSchema } from "../../forms/validationSchemas";
import { addSupplierInitialValues } from "../../forms/initialValues";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { AddSupplier } from "../../../features/supplier/supplierSlice";
import { useState } from "react";

interface IProps {
  handleClose: () => void;
  setOpenSnackbar: () => void;
  getSupplier: () => void;
  setAddSupplierId?: any;
}

const AddSupplierModal = ({
  handleClose,
  setOpenSnackbar,
  getSupplier,
  setAddSupplierId,
}: IProps) => {
  const dispatch = useAppDispatch();
  const [apiError, setApiError] = useState(""); // state for api fail error message
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: any) => {
    setLoading(true); // start the loader
    const pharmacyId = localStorage?.getItem("pharmacyId");
    const supplier: any = {
      ...values,
      pharmacy_id: pharmacyId,
    };

    try {
      const res = await dispatch(AddSupplier(supplier));
      if (res?.payload?.success === true) {
        getSupplier();
        setOpenSnackbar();
        handleClose();
        setApiError("");
        setAddSupplierId(res?.payload?.data?.id);
      } else {
        setApiError(res?.payload);
        setLoading(false); // Stop the loader
      }
    } catch (error) {
      //setApiError(res?.payload);
      console.error("Error adding Supplier: ", error);
    } finally {
      setLoading(false); // Stop the loader
    }
  };

  return (
    <Formik
      initialValues={addSupplierInitialValues}
      validationSchema={addSupplierValidationSchema}
      onSubmit={handleSubmit}
    >
      <Form>
        <Box sx={{ mt: 0 }}>
          <Grid container spacing={2}>
            {/* Supplier Name/Company Field */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>
                Supplier Name/Company
              </Typography>
              <Field
                as={TextField}
                fullWidth
                variant="outlined"
                name="supplier_name"
                placeholder="Supplier name"
                inputProps={{ style: { padding: "10px 12px" } }}
              />
              <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                <ErrorMessage name="supplier_name" component="div" />
              </div>
            </Grid>

            {/* Contact Person Field */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>
                Contact Person
              </Typography>
              <Field
                as={TextField}
                fullWidth
                variant="outlined"
                name="contact_person"
                placeholder="contact person name"
                inputProps={{ style: { padding: "10px 12px" } }}
              />
              <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                <ErrorMessage name="contact_person" component="div" />
              </div>
            </Grid>

            {/* Phone# Field */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>
                Phone#
              </Typography>
              <Field
                as={TextField}
                fullWidth
                variant="outlined"
                name="phone_number"
                placeholder="03xx xxxxxxx"
                inputProps={{ style: { padding: "10px 12px" } }}
              />
              <div
                style={{
                  color: apiError ? "red" : "red",
                  fontSize: "12px",
                  marginTop: "5px",
                }}
              >
                {apiError ? (
                  <div>{apiError}</div>
                ) : (
                  <ErrorMessage name="phone_number" component="div" />
                )}
              </div>
            </Grid>

            {/* Email Field */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>
                Email
              </Typography>
              <Field
                as={TextField}
                fullWidth
                variant="outlined"
                name="email"
                placeholder="Enter email"
                inputProps={{ style: { padding: "10px 12px" } }}
              />
              <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                <ErrorMessage name="email" component="div" />
              </div>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ mt: 0 }}>
          <AppButton
            variant="contained"
            color="primary"
            type="submit"
            title={
              loading ? <CircularProgress size={24} color="inherit" /> : "Add"
            }
            sx={{ float: "right" }}
            disabled={loading} // Disable button when loading
          />
        </Box>
      </Form>
    </Formik>
  );
};

export default AddSupplierModal;
